var React = require('react');

function DifficultyLevelBlack2Pill (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Freeride_most-difficult"},[React.createElement("rect",{"id":"Rectangle","fill":"#E7993B","x":"0","y":"0","width":"44","height":"24","rx":"12","key":0}),React.createElement("path",{"d":"M28.5060967,2.76784589 L22.5,9.76784589 L16.4939033,2.76784589 L8.65882238,11.8994949 L16.4938765,21.0311127 L22.5,14.0300916 L28.5061235,21.0311127 L36.3411776,11.8994949 L28.5060967,2.76784589 Z","id":"Combined-Shape","stroke":"#F4F4F4","fill":"#333333","key":1})])));
}

DifficultyLevelBlack2Pill.defaultProps = {"viewBox":"0 0 44 24","version":"1.1"};

module.exports = DifficultyLevelBlack2Pill;

DifficultyLevelBlack2Pill.default = DifficultyLevelBlack2Pill;
